<script setup>
// NOOVI: lista de resultados de busca para Pipeline Cards (Gap B — fase-10).
import { useMapGetter } from 'dashboard/composables/store.js';

import SearchResultSection from './SearchResultSection.vue';
import SearchResultPipelineCardItem from './SearchResultPipelineCardItem.vue';

defineProps({
  pipelineCards: {
    type: Array,
    default: () => [],
  },
  query: {
    type: String,
    default: '',
  },
  isFetching: {
    type: Boolean,
    default: false,
  },
  showTitle: {
    type: Boolean,
    default: true,
  },
});

const accountId = useMapGetter('getCurrentAccountId');
</script>

<template>
  <SearchResultSection
    :title="$t('SEARCH.SECTION.PIPELINE_CARDS')"
    :empty="!pipelineCards.length"
    :query="query"
    :show-title="showTitle"
    :is-fetching="isFetching"
  >
    <ul v-if="pipelineCards.length" class="space-y-3 list-none">
      <li v-for="card in pipelineCards" :key="card.id">
        <SearchResultPipelineCardItem
          :title="card.title"
          :pipeline-stage="card.pipelineStage"
          :contact-name="card.contact && card.contact.name"
          :account-id="accountId"
          :created-at="card.createdAt"
        />
      </li>
    </ul>
  </SearchResultSection>
</template>
